module.exports = __webpack_public_path__ + "assets/645aca278bb260493a667b1da7dddc65.svg";